import React, { PureComponent } from 'react'
import {
  TableRow,
  TableCell,
  Button,
  Grid,
  ListItem,
  MenuItem,
  InputAdornment,
  Paper,
} from '@material-ui/core'

import { EditableTextField, EditableSelect, EditableInput } from '../common/EditableComponents'
import { TableCellWithSwitch } from '../common/PureItems'
import { getAssetType } from '../../utils/Image'
import { uploadAssetAPI } from '../../api/assets'
import { addMessageCurry } from '../../utils/api'
import '../../style/StyleButtonFile.scss'
import CreateActionRegion from '../common/CreateActionRegion'
import { Element } from 'react-scroll'
import PerfectScrollbar from 'react-perfect-scrollbar'
import KmlUtils from '../../utils/kml-utils'
import { Appcues } from '../../utils/constants'
//import KmlUtils from '../../utils/kml-utils'

const options = [
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
  { label: 'Sunday', value: 'Sunday' },
]

const styles = {
  fontFamily: 'sans-serif',
  textAlign: 'center',
  display: 'flex',
}

export default class RegionsCreate extends PureComponent {
  constructor(props) {
    super(props)
    this.handleButtonFile = this.handleButtonFile.bind(this)
    this.state = {
      files: [],
      flag: true,
    }
  }

  state = {
    open: false,
  }

  handleOpen = () => {
    this.setState({
      open: true,
    })
  }

  onSave = () => {
    this.props.onSave()
    this.props.disableEdit() //TODO: what does this do?
  }

  handleClose = () => {
    this.setState({
      open: false,
    })
  }

  toogleEmptyRegion = () => {
    console.log('ingresa')
    this.setState({
      flag: false,
    })
  }

  onUpload = (file) => {
    const { imageUploadAPI } = this.props
    const type = getAssetType(file.name)

    const apiToHit = imageUploadAPI || uploadAssetAPI

    this.handleClose()

    addMessageCurry(apiToHit(file, type), this.props.dispatch).then((photo) => {
      if (this.props.onUpload) {
        this.props.onUpload(photo)
      }
    })
  }

  handleButtonFile(e) {
    var file = e.target.files[0]
    const kmlUtils = new KmlUtils()
    let fileReader = new FileReader()
    if (file) {
      fileReader.onload = async (e) => {
        let result = await kmlUtils.extractGoogleCoords(e.target.result)
        if (result && result.polygons && result.polygons.length > 1) {
          console.log('More than 1 polygon')
          //return
        } else {
          uploadAssetAPI(file, 'kml').then((response) => {
            let kmlEdge = {
              active: true,
              coordinates: result && result.polygons && result.polygons[0],
              asset: response,
            }
            this.props.onChange('kmlEdges', [...(this.props.data.kmlEdges || []), kmlEdge])
            console.log('KMLparsing', this.state.kmlEdges)
          })
        }
      }
      fileReader.readAsText(file)
    }
    // var files = e.target.files;
    // console.log(files);
    // var filesArr = Array.prototype.slice.call(files);
    // console.log(filesArr);
    // this.props.onChange('fileZone',files);
    // this.setState({ files: [...this.state.files, ...filesArr] });
  }

  removeFile(f) {
    this.setState({ files: this.state.files.filter((x) => x !== f) })
  }

  componentDidMount() {
    const { data = {} } = this.props
  }

  componentWillReceiveProps(nextProps) {
    const { data = {}, locationChanged } = nextProps

    if (locationChanged != this.props.locationChanged) {
      // eslint-disable-line

      this.getAddressFromLatLng(data)
    }
  }

  getAddressFromLatLng = ({ latitude, longitude }) => {
    const { Geocode } = this.props
    if (latitude && longitude) {
      Geocode.fromLatLng(latitude, longitude).then(
        (response) => {
          const address = response.results[0].formatted_address
          this.setState({
            location: address,
          })
        },
        (error) => {
          //console.error(error);
        },
      )
    }
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      const value = isCheckBox ? event.target.checked : event.target.value
      console.log('value', value)
      console.log('key', key)
      this.props.onChange(key, value)
    }

  render() {
    console.log('this.propsv1', this.props)
    const { data = {} } = this.props
    const { active, regionDefault, activeFile } = data || {}
    console.log('data', data)

    return (
      <div>
        <Grid container>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Region Name
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableTextField
                  valueToRender={data.name}
                  editMode={true}
                  value={data.name}
                  onChange={this.onChange('name')}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder={'Region Name'}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Active
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <TableCellWithSwitch
                  valueToRender={active ? 'Enabled' : 'Disabled'}
                  checked={active}
                  editMode={true}
                  onChange={this.onChange('active', true)}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Default Region
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <TableCellWithSwitch
                  valueToRender={regionDefault ? 'Enabled' : 'Disabled'}
                  checked={regionDefault}
                  editMode={true}
                  onChange={this.onChange('regionDefault', true)}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Region Type
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableSelect
                  valueToRender={data.regionType}
                  editMode={true}
                  value={data.regionType}
                  onChange={this.onChange('regionType')}
                >
                  <MenuItem value="Delivery">Delivery</MenuItem>
                  <MenuItem value="Pickup">Pickup</MenuItem>
                </EditableSelect>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Delivery Fee
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableInput
                  id="outlined-adornment-amount"
                  type="number"
                  value={data.deliveryFee}
                  editMode={true}
                  onChange={this.onChange('deliveryFee')}
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  labelWidth={60}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Opening Hours
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <PerfectScrollbar>
                  <EditableTextField
                    valueToRender={data.openAt}
                    editMode={true}
                    value={data.openAt}
                    onChange={this.onChange('openAt')}
                    type="time"
                  />
                </PerfectScrollbar>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Closing Hours
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableTextField
                  valueToRender={data.closeAt}
                  editMode={true}
                  value={data.closeAt}
                  onChange={this.onChange('closeAt')}
                  type="time"
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Days Closed
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}></Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Min Cart Subtotal
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableInput
                  id="outlined-adornment-amount"
                  type="number"
                  value={data.minOrderAmount}
                  editMode={true}
                  onChange={this.onChange('minOrderAmount')}
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  labelWidth={60}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Free Delivery after
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableInput
                  type="number"
                  value={data.freeDeliveryAfter}
                  editMode={true}
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  onChange={this.onChange('freeDeliveryAfter')}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Zones
              </Grid>
              <div style={styles}>
                <label className="custom-file-upload">
                  <input type="file" accept=".kml" multiple onChange={this.handleButtonFile} />
                  <i className="fa fa-cloud-upload" /> Upload KML
                </label>
                <TableRow>
                  {this.state.files.map((x) => (
                    <div className="file-preview" onClick={this.removeFile.bind(this, x)}>
                      <TableCell>{x.name}</TableCell>
                    </div>
                  ))}
                </TableRow>
              </div>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}></Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <Button variant="contained">Download</Button>
              </Grid>
              <Grid
                className="editField"
                item
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{ borderBottom: 'aliceblue' }}
              >
                <TableCellWithSwitch
                  valueToRender={active ? 'Enabled' : 'Disabled'}
                  checked={activeFile}
                  editMode={true}
                  onChange={this.onChange('activeFile', true)}
                />
              </Grid>
            </Grid>
          </ListItem>

          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={3} sm={3} md={3} lg={3}>
                Tax Rule
              </Grid>
              <Grid className="editField" item xs={3} sm={3} md={3} lg={3}>
                <EditableSelect
                  valueToRender={data.taxRule}
                  editMode={true}
                  value={data.taxRule}
                  onChange={this.onChange('taxRule')}
                >
                  <MenuItem value="Angeles">Los Angeles</MenuItem>
                </EditableSelect>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid className="editField" item xs={2} sm={2} md={2} lg={2}>
              <CreateActionRegion
                //onSave={this.onSave}
                onSave={this.onSave}
                onCancel={this.props.onCancel}
              />
            </Grid>
            <Grid className="editField" item xs={2} sm={2} md={2} lg={2}>
              <Button variant="contained" onClick={this.toogleEmptyRegion}>
                Cancel
              </Button>
            </Grid>
          </ListItem>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Regions/RegionsCreate.js